"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _SkeletonCircle = _interopRequireDefault(require("conversations-skeleton-state/components/SkeletonCircle"));

var _SkeletonText = _interopRequireDefault(require("conversations-skeleton-state/components/SkeletonText"));

var _SkeletonBox = _interopRequireDefault(require("conversations-skeleton-state/components/SkeletonBox"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 18px 20px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  margin-right: 5px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  height: 42px;\n  padding: 5px 25px;\n  justify-content: space-between;\n  border-bottom: 1px solid #dfe3eb;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-left: 6px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  padding: 17px 18px;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  min-height: 300px;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SkeletonWrapper = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__SkeletonWrapper",
  componentId: "y9nkz1-0"
})(_templateObject());

var CallSettingsWrapper = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__CallSettingsWrapper",
  componentId: "y9nkz1-1"
})(_templateObject2());

var ToPhoneNumberWrapper = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__ToPhoneNumberWrapper",
  componentId: "y9nkz1-2"
})(_templateObject3());

var ToPhoneNumber = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__ToPhoneNumber",
  componentId: "y9nkz1-3"
})(_templateObject4());

var Footer = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__Footer",
  componentId: "y9nkz1-4"
})(_templateObject5());

var ToolsWrapper = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__ToolsWrapper",
  componentId: "y9nkz1-5"
})(_templateObject6());

var Plugin = (0, _styledComponents.default)(_SkeletonBox.default).withConfig({
  displayName: "TwilioSkeletonState__Plugin",
  componentId: "y9nkz1-6"
})(_templateObject7());

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "TwilioSkeletonState__ButtonWrapper",
  componentId: "y9nkz1-7"
})(_templateObject8());

function TwilioSkeletonState() {
  return _react.default.createElement(SkeletonWrapper, null, _react.default.createElement(CallSettingsWrapper, null, _react.default.createElement(ToPhoneNumberWrapper, null, _react.default.createElement(_SkeletonCircle.default, {
    size: 52
  }), _react.default.createElement(ToPhoneNumber, null, _react.default.createElement(_SkeletonText.default, {
    width: 89
  }), _react.default.createElement(_SkeletonText.default, {
    width: 140
  }))), _react.default.createElement("div", null, _react.default.createElement(_SkeletonText.default, {
    width: 65
  }), _react.default.createElement(_SkeletonText.default, {
    width: 140
  }))), _react.default.createElement(Footer, null, _react.default.createElement(ToolsWrapper, null, _react.default.createElement("div", null, _react.default.createElement(Plugin, {
    width: 25,
    height: 25
  }), _react.default.createElement(Plugin, {
    width: 25,
    height: 25
  }), _react.default.createElement(Plugin, {
    width: 25,
    height: 25
  }), _react.default.createElement(Plugin, {
    width: 25,
    height: 25
  }), _react.default.createElement(Plugin, {
    width: 25,
    height: 25
  })), _react.default.createElement("div", null, _react.default.createElement(_SkeletonText.default, {
    width: 140
  }))), _react.default.createElement(ButtonWrapper, null, _react.default.createElement(_SkeletonBox.default, {
    width: 196,
    height: 35
  }))));
}

var _default = TwilioSkeletonState;
exports.default = _default;
module.exports = exports.default;